import React from "react";
import { useTranslation } from "react-i18next";
import Header from "./Header";
import "./aboutWomenConnect.css";

const AboutWomenConnect = ({ onBack, onSignIn, onJoinNow, onServices }) => {
  const { t } = useTranslation();

  return (
    <div className="aboutwc-container">
      <Header
        onSignIn={onSignIn}
        onJoinNow={onJoinNow}
        onAbout={() => {}}
        onHome={onBack}
        onServices={onServices}
        currentPage="about"
      />

      {/* Hero Section */}
      <section className="aboutwc-hero">
        <div className="aboutwc-hero-inner">
          <h1 className="aboutwc-title">
            {t("About")} <span className="aboutwc-highlight">{t("WomenConnect")}</span>
          </h1>
          <p className="aboutwc-subtitle">
            {t(
              "Empowering women entrepreneurs and connecting them with customers who value their services. Building a community where women support women."
            )}
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="aboutwc-mission">
        <h2 className="aboutwc-section-title">{t("Our Mission")}</h2>
        <p className="aboutwc-mission-text">
          {t(
            "WomenConnect was born from the belief that women deserve equal opportunities in business and entrepreneurship. We create a platform where women-owned businesses can thrive, where customers can discover amazing services, and where community support drives economic empowerment."
          )}
        </p>

        <div className="aboutwc-mission-cards">
          <div className="aboutwc-mission-card">
            <div className="aboutwc-card-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                  fill="#730637"
                />
              </svg>
            </div>
            <h3 className="aboutwc-card-title">{t("Community First")}</h3>
            <p className="aboutwc-card-description">
              {t(
                "Building a supportive network where women entrepreneurs can connect, learn, and grow together."
              )}
            </p>
          </div>

          <div className="aboutwc-mission-card">
            <div className="aboutwc-card-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <path
                  d="M20.84 4.61C19.32 3.79 17.58 3.79 16.06 4.61L12 7.04L7.94 4.61C6.42 3.79 4.68 3.79 3.16 4.61C1.64 5.43 0.68 7.04 0.68 8.84V20.28C0.68 21.6 1.76 22.68 3.08 22.68C3.64 22.68 4.16 22.48 4.56 22.08L12 14.64L19.44 22.08C19.84 22.48 20.36 22.68 20.92 22.68C22.24 22.68 23.32 21.6 23.32 20.28V8.84C23.32 7.04 22.36 5.43 20.84 4.61Z"
                  fill="#730637"
                />
              </svg>
            </div>
            <h3 className="aboutwc-card-title">{t("Empowerment")}</h3>
            <p className="aboutwc-card-description">
              {t(
                "Providing tools, resources, and opportunities for women to succeed in their entrepreneurial journey."
              )}
            </p>
          </div>

          <div className="aboutwc-mission-card">
            <div className="aboutwc-card-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z"
                  fill="#730637"
                />
              </svg>
            </div>
            <h3 className="aboutwc-card-title">{t("Trust & Safety")}</h3>
            <p className="aboutwc-card-description">
              {t(
                "Ensuring a safe, trusted environment for both women service providers and customers."
              )}
            </p>
          </div>
        </div>
      </section>

      {/* Impact Section */}
      <section className="aboutwc-impact">
        <h2 className="aboutwc-section-title">{t("Our Impact")}</h2>
        <div className="aboutwc-stats-grid">
          <div className="aboutwc-stat-item">
            <div className="aboutwc-stat-number">2,500+</div>
            <div className="aboutwc-stat-label">{t("Women Entrepreneurs")}</div>
          </div>
          <div className="aboutwc-stat-item">
            <div className="aboutwc-stat-number">15,000+</div>
            <div className="aboutwc-stat-label">{t("Happy Customers")}</div>
          </div>
          <div className="aboutwc-stat-item">
            <div className="aboutwc-stat-number">50+</div>
            <div className="aboutwc-stat-label">{t("Cities Covered")}</div>
          </div>
          <div className="aboutwc-stat-item">
            <div className="aboutwc-stat-number">4.8</div>
            <div className="aboutwc-stat-label">{t("Average Rating")}</div>
          </div>
        </div>
      </section>

      {/* Back to Home */}
      <div className="aboutwc-back-home" onClick={onBack}>
        — {t("Back to Home")}
      </div>
    </div>
  );
};

export default AboutWomenConnect;
